module.exports = __webpack_public_path__ + "img/hc.05774449.jpg";